"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _config = require("../../../../../../../../../../services/config");
var _handlers = require("../../../../../../../../../../helpers/handlers");
var _selectors = require("../../../../../../store/selectors");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ConditionLink = function ConditionLink() {
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS'),
    t = _useTranslation.t;
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.getBookingOperator),
    conditionsLink = _useSelector.conditionsLink,
    operatorName = _useSelector.name;
  var handleClickByConditionLink = function handleClickByConditionLink() {
    var callback = (0, _config.getOnClickByConditionBookingLink)();
    callback(conditionsLink);
  };
  return conditionsLink && /*#__PURE__*/_react.default.createElement("a", {
    className: _styles.default.footerLink,
    href: conditionsLink,
    onClick: (0, _handlers.handleWith)(_handlers.prevent, handleClickByConditionLink)
  }, t('OPERATOR_BOOKING_CONDITIONS', {
    operator: operatorName
  }));
};
var _default = exports.default = (0, _react.memo)(ConditionLink);